export class RequestBuilder {

    data?: any                  // Payload
    path?: any[]

    /**
     * Costruttore di richieste per il Web Service
     * @param data payload
     */
    constructor(data?: any, path?: any[]) {
        if (data) {
            this.data = data
        }
        if (path) {
            this.path = path
        }
    }

}